<template>
  <v-dialog
    v-model="open"
    transition="dialog-bottom-transition"
    :max-width="media_type === 'image' ? 'fit-content' : '80vw'"
    @click:outside="closeModal"
    @keydown.esc="closeModal"
    content-class="modal-imagem-dialog"
  >
    <v-card flat color="transparent" class="modal-imagem-card" elevation="0">
      <v-btn icon small class="sc-modal__close" @click="closeModal">
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header sc-modal__header--divided">
        <v-icon size="20" class="mr-2" color="text_secondary">mdi-image-outline</v-icon>
        <div>
          <span class="sc-modal__title">Visualizar mídia</span>
        </div>
      </div>

      <div class="modal-imagem-content">
        <template v-if="media_type === 'image'">
          <div v-show="mediaState === 'loading'" class="sc-loading modal-imagem-placeholder">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <img
            v-if="midia_url && mediaState !== 'error'"
            v-show="mediaState === 'loaded'"
            :src="midia_url"
            alt="Imagem"
            class="modal-imagem-img"
            @load="mediaState = 'loaded'"
            @error="mediaState = 'error'"
          />
          <div v-if="mediaState === 'error'" class="sc-empty-state modal-imagem-error">
            <v-icon size="48" color="text_secondary" class="mb-2">mdi-image-off-outline</v-icon>
            <span class="sc-empty-state__title">Imagem indisponível</span>
            <span class="sc-empty-state__subtitle">O link da mídia está quebrado ou expirado</span>
          </div>
        </template>

        <template v-else>
          <div v-show="mediaState === 'loading'" class="sc-loading modal-imagem-placeholder">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <video
            v-if="midia_url && mediaState !== 'error'"
            v-show="mediaState === 'loaded'"
            :key="midia_url"
            ref="videoPlayer"
            class="modal-imagem-video"
            controls
            autoplay
            @loadedmetadata="mediaState = 'loaded'"
            @error="mediaState = 'error'"
          >
            <source :src="midia_url" type="video/mp4" @error="mediaState = 'error'" />
          </video>
          <div v-if="mediaState === 'error'" class="sc-empty-state modal-imagem-error">
            <v-icon size="48" color="text_secondary" class="mb-2">mdi-video-off-outline</v-icon>
            <span class="sc-empty-state__title">Vídeo indisponível</span>
            <span class="sc-empty-state__subtitle">O link da mídia está quebrado ou expirado</span>
          </div>
        </template>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalImagem",
  props: {
    midia_url: { type: String, default: null },
    media_type: { type: String, default: "image" },
    dialog: { type: Boolean, default: false },
  },
  data() {
    return {
      mediaState: "loading", // loading | loaded | error
    };
  },
  computed: {
    open: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
  },
  watch: {
    midia_url() {
      this.mediaState = "loading";
    },
  },
  methods: {
    closeModal() {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
        this.$refs.videoPlayer.currentTime = 0;
      }
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.modal-imagem-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss" scoped>
.modal-imagem-card {
  background: var(--v-surface_secondary-base) !important;
  border-radius: var(--sc-radius-xl) !important;
  overflow: hidden;
  position: relative;
  max-height: 85vh;
}

.modal-imagem-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.modal-imagem-img {
  max-height: 75vh;
  max-width: 75vw;
  object-fit: contain;
  border-radius: var(--sc-radius-md);
  display: block;
}

.modal-imagem-video {
  max-width: 80vw;
  max-height: 70vh;
  border-radius: var(--sc-radius-lg);
  object-fit: contain;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

.modal-imagem-placeholder {
  width: 300px; // keep fit-content modal stable while the spinner shows
}

.modal-imagem-error {
  width: 300px;
}
</style>
